import ChargingStationPage from "./chargingStation";

export default ChargingStationPage;